import { render, staticRenderFns } from "./FormPax.vue?vue&type=template&id=041d8177&scoped=true"
import script from "./FormPax.vue?vue&type=script&lang=js"
export * from "./FormPax.vue?vue&type=script&lang=js"
import style0 from "./FormPax.vue?vue&type=style&index=0&id=041d8177&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041d8177",
  null
  
)

export default component.exports